import type { IconProps } from '.';

/**
 * Arrow Top Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const ArrowTopIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8536 8.56062L7.70711 12.7071L7 12L12.3536 6.64641L17.7071 12L17 12.7071L12.8536 8.56062L12.8536 17.3535L11.8536 17.3535L11.8536 8.56062Z"
      fill="white"
    />
  </svg>
);

export default ArrowTopIcon;
